import { normalizeJoinPolicy, VCS_JOIN_POLICY } from 'consts';
import { IN_ROOM } from 'consts';
import { selectIsAuthorized, selectRoom, selectRoomMetadata } from 'state/selectors';
import { WaitingUserInfo } from 'api/types';
import { isLocalUserModerator } from 'useCase/moderation/status/moderators';

export const useWaitingRoom = () => {
    const metadata = selectRoomMetadata();
    const isInActiveRoom = Boolean(selectRoom()) || sessionStorage.getItem(IN_ROOM) === '1';
    const waitingUsers: WaitingUserInfo[] = isInActiveRoom ? metadata?.joinApprovalData?.waitingUsers || [] : [];
    const policy = metadata?.joinApprovalData?.joinApprovalPolicy;
    const isApprovalMode = normalizeJoinPolicy(policy) !== VCS_JOIN_POLICY.ALL;
    const onlyModerators = Boolean(metadata?.joinApprovalData?.onlyModeratorsCanApproveWaitingUsers);
    const isAuthorized = selectIsAuthorized();
    const isCanManageWaitingUsers = isApprovalMode && (onlyModerators ? isLocalUserModerator() : isAuthorized);

    return {
        waitingUsers,
        isCanManageWaitingUsers,
        isApprovalMode,
    };
};
